export const css = {
    root: '_1FfNsvxj',
    ' _key': 'ascm-theme/ascm/landing-page/general'
};
export default css;
